/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_168_TitleInputs */

const en_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strawberry Macaron`)
};

const ar_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماكارون الفراولة`)
};

const de_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erdbeer-Macaron`)
};

const es_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de fresa`)
};

const fr_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron à la fraise`)
};

const it_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron alla fragola`)
};

const ja_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストロベリーマカロン`)
};

const ko_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`딸기 마카롱`)
};

const pt_br_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Macaron de Morango`)
};

const ru_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Клубничный макарон`)
};

const th_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มาการองสตรอว์เบอร์รี`)
};

const tr_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çilekli Makaron`)
};

const zh_cn_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草莓马卡龙`)
};

const zh_tw_tree_type_168_title = /** @type {(inputs: Tree_Type_168_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草莓馬卡龍`)
};

/**
* | output |
* | --- |
* | "Strawberry Macaron" |
*
* @param {Tree_Type_168_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_168_title = /** @type {((inputs?: Tree_Type_168_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_168_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_168_title(inputs)
	if (locale === "ar") return ar_tree_type_168_title(inputs)
	if (locale === "de") return de_tree_type_168_title(inputs)
	if (locale === "es") return es_tree_type_168_title(inputs)
	if (locale === "fr") return fr_tree_type_168_title(inputs)
	if (locale === "it") return it_tree_type_168_title(inputs)
	if (locale === "ja") return ja_tree_type_168_title(inputs)
	if (locale === "ko") return ko_tree_type_168_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_168_title(inputs)
	if (locale === "ru") return ru_tree_type_168_title(inputs)
	if (locale === "th") return th_tree_type_168_title(inputs)
	if (locale === "tr") return tr_tree_type_168_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_168_title(inputs)
	return zh_tw_tree_type_168_title(inputs)
});